<template>
  <div id="login-page" class="bg-account-delete">
    <div class="d-flex align-items-center justify-content-around page-account-delete">
      <el-row class="box-contents-delete">
        <el-col :span="12" class="box-description">
          <div class="bg-overlay"></div>
          <div class="box-content-description">
            <div class="mt-auto">
              <div class="mb-3">
                <i class="el-icon-"></i>
              </div>
            </div>
            " Dear You. <br>
            We hope this message finds you well. We regret to inform you that your account with us has been deactivated due to [mention the reason, if applicable].
            Unfortunately, this action is irreversible, and your account is scheduled for deletion within the next 7 days.<br>
            Please note that after the specified period, all associated data, including account information and content, will be permanently removed from our system.<br>
            If you believe this deactivation is in error or if you have any concerns, please contact our support team at [support email or contact form] within the next 7 days.
            We will do our best to assist you during this time.<br>
            We appreciate your understanding in this matter.<br>
            Best regards, SCSoft Team
          </div>
        </el-col>
        <el-col  :span="12" class="box-login">
          <el-row style="margin-top: 50px;">
            <img src="../assets/images/logitembus_logo_2.jpg" width="70%"/>
          </el-row>
          <div @keydown.enter="submitLogin">
            <el-row style="display: inline-flex; margin-top: 50px; width: 100%">
              <el-col :span="6">
                <div class="lbl-login">Email:</div>
              </el-col>
              <el-col :span="18">
                <input class="input-login" v-model="loginInfo.email" type="text"/>
              </el-col>
            </el-row>
            <el-row style="display: inline-flex; margin-top: 60px; width: 100%">
              <el-col :span="24">
                <el-button style="font-size: 20px; width: 80%" type="success" @click="submitLogin">Delete Account</el-button>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  name: "Login",
  components: {

  },
  data: function () {
    return {
      loginInfo: {
        email: '',
        username: ''
      },
      route: ''
    }
  },
  methods: {
    submitLogin: function () {
      if(this.loginInfo.email){
        this.$store.commit('openNotification', {
          type: 'success',
          message: 'We have received your request and processed it within 7 days'
        })
      }else{
        this.$store.commit('openNotification', {
          type: 'error',
          message: 'Please enter your email'
        })
      }

    },
  }
}
</script>

<style lang="scss">
.lbl-login {
  text-align: left;
  font-size: 20px;
  line-height: 40px;
}

.input-login {
  height: 35px;
  width: 100%;
  font-size: 17px;
  padding: 7px;
  border-radius: 5px;
  border: 1px solid gainsboro;
}

#login-page input[type='checkbox'] {
  -webkit-appearance: none;
  width: 28px;
  height: 28px;
  background: white;
  border-radius: 5px;
  border: 2px solid #555;
}

#login-page input[type='checkbox']:checked {
  background-image: url("../assets/icon/done-icon.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.remember {
  font-size: 18px;
  line-height: 34px;
  padding-left: 10px;
}
.page-account-delete{
  height: 100vh;
  width: 100%;
  background-image: url("../assets/icon/bg-account-delete.png");
  background-position: center;
  background-size: cover;
  opacity: 1;
  background-color: transparent;
}
#login-page.bg-account-delete{
  background: linear-gradient(-45deg, #3d78e3 50%, #67b173);
  .box-contents-delete{
    background-color: #ffffff;
    width: 60vw;
    border-radius: 8px;
  }
  .box-description{
    background-image: url("../assets/icon/auth-one-bg.jpg");
    background-position: center;
    background-size: cover;
    height: 77vh;
    border-radius: 8px 0px 0px 8px;
    position: relative;
    .bg-overlay{
      background: linear-gradient(to right, #2265df, #3d78e3);
      opacity: .9;
      position: absolute;
      height: 100%;
      width: 100%;
      right: 0;
      bottom: 0;
      left: 0;
      top: 0;
      border-radius: 8px 0px 0px 8px;
    }
    .box-content-description{
      position: relative;
      display: flex;
      flex-direction: column;
      font-size: 20px;
      font-style:italic ;
      padding: 50px 30px 0px;
      color: rgba(255, 255, 255, .5);
      text-align: center;
    }
  }
  .box-login{
    padding: 40px;
  }
}
</style>
